export const QUOTE_ENTRY_PATHS = {
  quick: 'quick',
  personalise: 'personalise'
}

export const QUOTE_ENTRY_STORAGE_KEY = 'hi_quote_entry'

const FUNNEL_BASE = '/health-insurance/quote/form'

export const QUOTE_ENTRY_STEP0_ROUTE = `${FUNNEL_BASE}/step0/`

// Variant-only life-stage page the Personalise card leads to.
export const QUOTE_ENTRY_LIFE_STAGE_ROUTE = `${FUNNEL_BASE}/who-needs-health-cover/`

// Variant-only one-screen form the Quick Quote card leads to.
export const QUOTE_ENTRY_QUICK_QUOTE_ROUTE = `${FUNNEL_BASE}/quick-quote/`

export const QUOTE_ENTRY_DETAILS_ROUTE = `${FUNNEL_BASE}/details/`

export const QUOTE_ENTRY_TARGETS = {
  quick: QUOTE_ENTRY_QUICK_QUOTE_ROUTE,
  personalise: `${FUNNEL_BASE}/step1/`
}

export const QUOTE_ENTRY_COPY = {
  title: 'How would you like to',
  titleHighlight: 'get your health quote?',
  subtitle: 'Pick the option that',
  subtitleHighlight: 'works for you',
  subtitleEnd: '— both get you to the same great health cover.',
  footnote: 'Not sure? Most people start with the Quick Quote and personalise later.'
}

// Keys map to v2 icon components in QuoteEntryChoice (kept as plain data so this file has no .vue imports).
export const QUOTE_ENTRY_ICON_KEYS = {
  clock: 'clock',
  settings: 'settings'
}

export const QUOTE_ENTRY_CARDS = [
  {
    path: QUOTE_ENTRY_PATHS.quick,
    title: 'Quick Quote',
    icon: QUOTE_ENTRY_ICON_KEYS.clock,
    descriptionLead: 'Takes about',
    descriptionStrong: '1 minute',
    descriptionTail: '. Get an instant price estimate — perfect if you just want a fast ballpark before deciding.',
    ctaLabel: 'Get my quick quote',
    testid: 'health-quote-entry-quick-card'
  },
  {
    path: QUOTE_ENTRY_PATHS.personalise,
    title: 'Personalise Cover',
    icon: QUOTE_ENTRY_ICON_KEYS.settings,
    descriptionLead: 'Takes about',
    descriptionStrong: '3 minutes',
    descriptionTail: '. Answer a few extra questions so we can match you with the right cover at the best price.',
    ctaLabel: 'Personalise my quote',
    testid: 'health-quote-entry-personalise-card'
  }
]

export const isQuoteEntryPath = value => Object.values(QUOTE_ENTRY_PATHS).includes(value)

// Falls back to the personalise route so a bad config can never dead-end.
export const resolveQuoteEntryTarget = path => {
  return QUOTE_ENTRY_TARGETS[path] || QUOTE_ENTRY_TARGETS.personalise
}
